module.exports = "/static/assets/b77fe5cbd17bd82c89a19667e015cb4c.gif";